import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AddPromoCode from "../../../components/SuperAdmin/PromoCode/AddPromoCode";

export default withRouter(connect()(AddPromoCode));
